import styled from '@emotion/styled';
import { css } from '@emotion/react';

const alignToast = () => css`
  display: flex;
  align-items: center;
`;

export const WrapperToast = styled('div')(alignToast);
